'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from 'angular';


/**
 * Директива "project-table"
 * @return {{restrict: string, template: *, transclude: boolean, scope: {selectedItem: string, items: string, type: string, filters: string, ok: string, isPaging: string, isSearch: string, isFilter: string}, controller: [string,string,string,string,string,string,string,string,null]}}
 */
export default function() {
    return {
        restrict: 'A',
        template: require('../view/projects-trash-table.html'),
        transclude: true,
        scope: {
            selectedItem: '=?myValue',
            items: '=?myItems',
            type: '@myType',
            filters: '=?myFilters',
            ok: '=?myOk',
            isPaging: '=myPagination',
            isSearch: '=mySearching',
            isFilter: '=myFilter',
        },
        controller: ['$scope', '$utils', '$uibModal', 'ProjectService', 'Notification', '$location', '$security', '$log',
                     function($scope, $utils, $modal, ProjectService, Notification, $location, $security, $log) {
                         $scope.refresh = refresh;
                         $scope.dblClick = dblClick;
                         $scope.select = select;
                         $scope.isSelect = isSelect;
                         $scope.getItems = getItems;
                         $scope.statistic = {
                             totalItems: 0,
                             totalCost: 0,
                             totalPayment: 0,
                             totalWplaces: 0,
                         };

                         $scope.getValue = $utils.getValue;

                         let enableDelete = false;
                         let query = null;
                         let queryForStatistic = null;

                         init();

                         // region Functions

                         /**
                          * Инициализация
                          */
                         function init() {
                             $scope.loading = true;

                             if (!$scope.selectedItem) {
                                 $scope.selectedItem = ProjectService.getSelectItem();
                             }

                             $scope.columns = [{
                                name: 'Этап',
                                data: 'currentStage',
                            }, {
                                name: 'Код',
                                data: 'code',
                            }, {
                                name: 'Текущий этап',
                                data: 'phase.name',
                                type: 'percent',
                                style: (item) => {
                                    let value = item.phase != null ?
                                        'background: linear-gradient(90deg, #ecf0f5 0%, #ecf0f5 ' + item.percent + '%, transparent ' + item.percent + '%, transparent 100%);'
                                        : '';
        
                                    $log.debug('COLUMN:STYLE:', value);
        
                                    return value;
                                },
                                ngStyle: (item) => {
                                    let value = item.phase != null ? {
                                        background: 'linear-gradient(90deg, #ecf0f5 0%, #ecf0f5 ' + item.percent + '%, transparent ' + item.percent + '%, transparent 100%);',
                                    } : {};
        
                                    $log.debug('COLUMN:NG-STYLE:', value);
        
                                    return value;
                                },
                            }, {
                                name: 'Инициатор',
                                data: 'author',
                            }, {
                                name: 'Краткое наименование проекта',
                                data: 'shortName',
                                // type: 'href',
                                // href: (item) => {
                                //     return 'projects/' + item.id;
                                // }
                            }, {
                                name: 'Менеджер проекта',
                                data: 'manager',
                            }];

                             $scope.searching = {
                                 isSearch: $scope.isSearch,
                                 filter: null,
                             };

                             $scope.pagination = ProjectService.getPagination();

                             // тулбокс таблицы
                             $scope.toolbox = {
                                 // кнопки на панели управления
                                 buttons: {
                                     // создание
                                     create: {
                                         show: () => false,
                                         click: () => {
                                             ProjectService.create().result.then((data) => {
                                                 ProjectService.api.create(null, {'form': data}, (data) => {
                                                     ProjectService.edit(data._embedded);
                                                 });
                                             });
                                         },
                                         disabled: () => true,
                                     },
                                     // редактирование
                                     edit: {
                                         show: () => isSelected(),
                                         click: (item) => ProjectService.edit(item),
                                         disabled: () => $scope.selectedItem == null || $scope.selectedItem.id == null,
                                     },
                                     // удаление
                                     remove: {
                                         show: () => isSelected() && enableDelete,
                                         click: (item) => {
                                             ProjectService.remove(item, (data) => $scope.refresh());
                                         },
                                         disabled: () => $scope.selectedItem == null || $scope.selectedItem.id == null || !enableDelete,
                                     },
                                     // обновление таблицы
                                     refresh: {
                                         show: () => true,
                                         click: $scope.refresh,
                                         disabled: () => false,
                                     },
                                     // восстановление
                                     recovery: {
                                         show: () => isSelected() && enableDelete,
                                         click: (item) => {
                                             ProjectService.recovery(item, (data) => $scope.refresh());
                                         },
                                         disabled: () => $scope.selectedItem == null || $scope.selectedItem.id == null || !enableDelete,
                                     },
                                 },
                             };

                             // получение данных
                             //refresh();
                         }

                         /**
                          * Получение всех записей
                          * @return {*}
                          */
                         function getItems() {
                             return $scope.items;
                         }

                         /**
                          * Выбрал ли элемент!
                          * @param {*} item проверяемый элемент
                          * @return {bool}
                          */
                         function isSelect(item) {
                             return equals(getSelected(), item);
                         }

                         /**
                          * Выбрать элемент
                          * @param {*} item выбираемый элемент
                          */
                         function select(item) {
                             if (!$scope.isSelect(item)) {
                                 enableDelete = false;
                                 angular.copy(item, $scope.selectedItem);
                                 ProjectService.api.enableDelete({projectId: item.id}, (data) => {
                                     enableDelete = data._embedded;
                                 });
                             } else {
                                 angular.copy({}, $scope.selectedItem);
                             }
                             ProjectService.setSelectItem($scope.selectedItem);
                         }

                         /**
                          * Двойное нажатие на запись в таблице
                          * @param {*} item данные записи
                          */
                         function dblClick(item) {
                             switch ($scope.type) {
                                 case 'table':
                                     if ($scope.toolbox.buttons.edit) {
                                         $scope.toolbox.buttons.edit.click(item);
                                     }
                                     break;
                                 case 'select':
                                     $scope.ok();
                                     break;
                             }
                         }

                         /**
                          * Получение фильтров
                          * @return {Array}
                          */
                         function getFilters() {
                             let filters = [];
                             if (Array.isArray($scope.filters)) {
                                 filters = filters.concat($scope.filters);
                             }
                             filters.push(`'entityStatus' EQ 'DELETED'`);
                             return filters;
                         }

                         /**
                          * Получение поиска
                          * @return {Array}
                          */
                         function getSearchs() {
                             let searchs = [];
                             if ($scope.isSearch) {
                                 if ($scope.searching.filter != null && !($scope.searching.filter.length < 1)) {
                                     searchs.push(`'shortName':'${$scope.searching.filter}'`,
                                                  `'name':'${$scope.searching.filter}'`,
                                                  `'code':'${$scope.searching.filter}'`,
                                                  `'author.shortName':'${$scope.searching.filter}'`,
                                                  `'author.fullName':'${$scope.searching.filter}'`);
                                 }
                             }
                             return searchs;
                         }

                         /**
                          * Выбрана ли запись
                          * @return {boolean}
                          */
                         function isSelected() {
                             return $scope.selectedItem != null && !angular.equals($scope.selectedItem, {});
                         }

                         /**
                          * Проверка элементов на равенство
                          * @param {*} i1
                          * @param {*} i2
                          * @return {*}
                          */
                         function equals(i1, i2) {
                             return angular.equals(i1, i2);
                         }

                         /**
                          * Получить выбранный элемент
                          * @return {{}|*}
                          */
                         function getSelected() {
                             return $scope.selectedItem;
                         }

                         /**
                          * Обновить данные таблицы
                          */
                         function refresh() {
                            if (query) {
                                query.$cancelRequest();
                                query = null;
                            }

                             $scope.loading = true;

                             query = ProjectService.api.getAll({
                                                                   filters: getFilters(),
                                                                   searchs: getSearchs(),
                                                                   sorts: ['code:DESC', 'shortName:ASC', 'name:ASC'],
                                                                   page: $scope.pagination.page,
                                                                   size: $scope.pagination.size,
                                                               }, function(data) {
                                 $scope.items = angular.copy(data._embedded.items);
                                 if (isSelected()) {
                                     if ($scope.items.every((i) => i.id != getSelected().id)) {
                                         $scope.selectedItem = {};
                                     } else {
                                         angular.copy($scope.items.find((i) => i.id == getSelected().id), $scope.selectedItem);
                                     }
                                 }
                                 if ($scope.pagination.isPaging) {
                                     $scope.pagination.totalPages = data.page.totalPages;
                                     $scope.pagination.totalItems = data.page.totalElements;
                                 }

                                 $log.debug('REFRESH:ITEMS: ', $scope.items);

                                 $scope.loading = false;
                             });

                             //statistic();
                         }


                         /**
                          * Статистика
                          */
                         function statistic() {
                             $log.debug('STATISTIC:FILTERS: ', getFilters());

                             queryForStatistic = ProjectService.api.getStatistic({
                                                                                     filters: getFilters(),
                                                                                     searchs: getSearchs(),
                                                                                     sorts: ['code:DESC', 'shortName:ASC', 'name:ASC'],
                                                                                     page: 1,
                                                                                     size: null,
                                                                                 }, function(data) {
                                 $scope.statistic = data._embedded;
                                 $log.debug('STATISTIC:ITEMS: ', $scope.statistic);
                             });
                         }

                         // endregion

                         // region Watchers

                         $scope.$watch('filters', function(nw, old) {
                             $log.debug('FILTERS:NEW: ', nw);
                             $log.debug('FILTERS:OLD: ', old);

                             if (query) {
                                 $log.debug('FILTERS:QUERY: ', query);
                                 query.$cancelRequest();
                                 query = null;
                             }

                             if (queryForStatistic) {
                                 $log.debug('FILTERS:QUERY_FOR_STATISTIC: ', queryForStatistic);
                                 queryForStatistic.$cancelRequest();
                                 queryForStatistic = null;
                             }

                             $scope.refresh();
                         });

                        //  $scope.$watch('currentSupportStage', function(nw, old) {
                        //      $log.debug('FILTERS:CURRENT_SUPPORT_STAGE:NEW: ', nw);
                        //      $log.debug('FILTERS:CURRENT_SUPPORT_STAGE:OLD: ', old);

                        //      if (query) {
                        //          $log.debug('FILTERS:CURRENT_SUPPORT_STAGE:QUERY: ', query);
                        //          query.$cancelRequest();
                        //          query = null;
                        //      }

                        //      if (queryForStatistic) {
                        //          $log.debug('FILTERS:CURRENT_SUPPORT_STAGE:QUERY_FOR_STATISTIC: ', queryForStatistic);
                        //          queryForStatistic.$cancelRequest();
                        //          queryForStatistic = null;
                        //      }

                        //      $scope.refresh();
                        //  });

                         // endregion
                     }],
    };
}
